import { ActiveRowInfo } from './types';

export const getEmptyActiveRow = (): ActiveRowInfo => ({
  index: -1,
  element: undefined,
});
